

<script>

	import SuspendingAccountModal from './SuspendingAccountModal.svelte'

	export let docDataCuenta = {}

	const boxes = [
		{
			img: 'https://static.wixstatic.com/media/2ad937_c9d0eeed91d54dbc9b038a3df61a6edf~mv2.jpg/v1/crop/x_160,y_0,w_640,h_640/fill/w_300,h_300,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/20230518051827_%5Bfpdl_edited.jpg',
			name: 'Usuarios y Cuenta',
			url: '../../02_micuenta/mi_cuenta.html'
		},
		{
			img: 'https://static.wixstatic.com/media/2ad937_64b37aeaf188434cb284ac35d1810d31~mv2.jpg/v1/crop/x_160,y_0,w_640,h_640/fill/w_300,h_300,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/20230518053450_%5Bfpdl_in%5D_joven-ingeniero-guapo-casco-blanco_93675-59487_large.jpg',
			name: 'Proyectos',
			url: '../../01_proyectos/00_proyectos.html',
			class: docDataCuenta.isNewAccount ? 'scale-box' : ''
		},
		{
			img: 'https://static.wixstatic.com/media/2ad937_d8844d8132a24036955a9d37cd42aac2~mv2.jpg/v1/crop/x_320,y_0,w_640,h_640/fill/w_300,h_300,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/20230518054307_%5Bfpdl_in%5D_silueta-cargador-excavador-sitio-construccion-fondo-cielo-atardec.jpg',
			name: 'Bases de Datos',
			url: '../../03_bases/bases.html'
		},
		{
			img: 'https://static.wixstatic.com/media/2ad937_a6b59570c9ab43fda7cd188c96e34d1a~mv2.jpg/v1/crop/x_160,y_0,w_640,h_640/fill/w_300,h_300,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/20230518051920_%5Bfpdl_in%5D_guantes-herramientas-espacio-copia_23-2148393099_large.jpg',
			name: 'Gestión Documental',
			url: '../../gestion_terceros/'
		},
	]

	const getStyle = (box) => {
		return `background-image: url(${box.img});`
	}

	console.log(docDataCuenta)

</script>

<main>

	<SuspendingAccountModal {docDataCuenta} />

	<div class="section-container">


		{#each boxes as box (box.name)}

			<a class="card" href={box.url}>

				{#if docDataCuenta.isNewAccount && box.name === 'Proyectos'}
					<span class="new-account-message">
						Bienvenido a metrokubiko, vamos a crear tu primer proyecto en la plataforma.
						<div class="action-message">Haz click aqui</div>
					</span>
					<div class="new-account-shadow" />
				{/if}

				<div class="card-box {box.class || ''}">

					<div class="background" style={getStyle(box)} />
					<div class="shadow" />
					<div class="box">
						{box.name}
					</div>

				</div>

			</a>

		{/each}

	</div>

</main>

<style>

	main {
		justify-content: center;
		flex-direction: column;
		align-items: center;
		background: #fff;
		display: flex;
		flex: auto;
		padding: 20px;
		/*min-height: min(70vw, 500px);*/
	}

	.section-container {
		justify-content: center;
		display: grid;
		gap: 30px;
		padding: 65px 0px;
		grid-template-columns: repeat(auto-fill, min(100%, 300px));
	}

	.card {
		justify-content: center;
		flex-direction: column;
		text-decoration: none;
		align-items: center;
		position: relative;
		display: flex;
		min-height: 300px;
	}

	.card-box {
		position: relative;
		overflow: hidden;
		padding: 20px;
		width: 100%;
		height: 100%;
		background-color: rgb(0, 47, 70);
	}

	.card-box.scale-box {
    animation: scale-box 2s linear infinite;
	}

	@keyframes scale-box {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.1);
		}
		100% {
			transform: scale(1);
		}
	}

	.new-account-message {
    background: #ff246d;
    position: absolute;
    width: 250px;
    color: white;
    z-index: 10;
    top: 50px;
    font-weight: 600;
    padding: 20px 30px;
    border-radius: 5px;
	}

	.new-account-message .action-message {
	  text-align: center;
	  margin-top: 5px;
	  font-weight: 900;
	}

	.new-account-shadow {
		display: none;
		position: absolute;
    width: calc(100% + 20px);
    height: calc(100% + 20px);
    background: rgb(255 152 0 / 70%);
    /*border: 1px solid rgb(255 152 0 / 100%);*/
    animation: scale-box 2s linear infinite;
    box-shadow: 0px 0px 20px 0px rgb(255 152 0 / 50%);
    border-radius: 4px;
	}

	.card .background {
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		position: absolute;
		top: 0;
		left: 0;
		margin: 0px;
		width: 100%;
		height: 100%;
		transition: all .5s;
	}

	.card .shadow {
		position: absolute;
		top: 0;
		left: 0;
		margin: 0px;
		width: 100%;
		height: 100%;
		transition: background .5s;
		background: linear-gradient(0deg, rgba(55,59,60,.5) -20%, transparent 70%);
	}

	.card .box {
		text-transform: uppercase;
		justify-content: center;
		align-items: flex-end;
		position: relative;
		display: flex;
		color: #fff;
		width: 100%;
		height: 100%;
		padding: 15px;
		font-size: 1rem;
		border: 2px solid;
		letter-spacing: 1px;
	}

	.card:hover .background {
		opacity: .5;
		transform: scale(1.1);
	}

</style>

